import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { baseUrl } from "../Utils/api";

const initialState = {
  receivables: [],
  receivablesLoading: false,
  receivablesError: null,
  recoveryStatus: [],
  recoveryStatusLoading: false,
  recoveryStatusError: null,
  pagination: {
    page: 0,
    size: 20,
    totalElements: 0,
    totalPages: 0
  },
  emailReminderLoading: false,
  emailReminderError: null,
  emailReminderSuccess: false,
};

export const fetchReceivables = createAsyncThunk(
  'debtManagement/fetchReceivables',
  async ({ page = 0, size = 20 }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('auth-token');
      const response = await axios.get(
        `${baseUrl}/sales/premium/receivables?page=${page}&size=${size}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchRecoveryStatus = createAsyncThunk(
  'debtManagement/fetchRecoveryStatus',
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('auth-token');
      const response = await axios.get(
        `${baseUrl}/sales/premium/recovery-status`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const sendPremiumEmailReminder = createAsyncThunk(
  'debtManagement/sendPremiumEmailReminder',
  async (id, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('auth-token');
      const response = await axios.get(
        `${baseUrl}/sales/premium/email-remainder/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const debtManagementSlice = createSlice({
  name: 'debtManagement',
  initialState,
  reducers: {
    resetEmailReminder: (state) => {
      state.emailReminderLoading = false;
      state.emailReminderError = null;
      state.emailReminderSuccess = false;
    }
  },
  extraReducers: (builder) => {
    builder
      // Receivables
      .addCase(fetchReceivables.pending, (state) => {
        state.receivablesLoading = true;
        state.receivablesError = null;
      })
      .addCase(fetchReceivables.fulfilled, (state, action) => {
        state.receivablesLoading = false;
        state.receivables = action.payload?.result?.content || [];
        state.pagination = {
          page: action.payload.result.property.page_number,
          size: action.payload.result.property.page_size,
          totalElements: action.payload.result.property.total_elements,
          totalPages: action.payload.result.property.total_pages
        };
      })
      .addCase(fetchReceivables.rejected, (state, action) => {
        state.receivablesLoading = false;
        state.receivablesError = action.payload || 'Failed to fetch receivables';
      })
      // Recovery Status
      .addCase(fetchRecoveryStatus.pending, (state) => {
        state.recoveryStatusLoading = true;
        state.recoveryStatusError = null;
      })
      .addCase(fetchRecoveryStatus.fulfilled, (state, action) => {
        state.recoveryStatusLoading = false;
        state.recoveryStatus = action.payload?.result || [];
        console.log(state.recoveryStatus, "state.recoveryStatus");
      })
      .addCase(fetchRecoveryStatus.rejected, (state, action) => {
        state.recoveryStatusLoading = false;
        state.recoveryStatusError = action.payload || 'Failed to fetch recovery status';
      })
      // Email Reminder
      .addCase(sendPremiumEmailReminder.pending, (state) => {
        state.emailReminderLoading = true;
        state.emailReminderError = null;
        state.emailReminderSuccess = false;
      })
      .addCase(sendPremiumEmailReminder.fulfilled, (state, action) => {
        state.emailReminderLoading = false;
        state.emailReminderSuccess = true;
      })
      .addCase(sendPremiumEmailReminder.rejected, (state, action) => {
        state.emailReminderLoading = false;
        state.emailReminderError = action.payload || 'Failed to send email reminder';
        state.emailReminderSuccess = false;
      });
  },
});

export const { resetEmailReminder } = debtManagementSlice.actions;

export default debtManagementSlice.reducer;